import { render, staticRenderFns } from "./PainelAgetic.vue?vue&type=template&id=1b82f968"
import script from "./PainelAgetic.vue?vue&type=script&lang=js"
export * from "./PainelAgetic.vue?vue&type=script&lang=js"
import style0 from "./PainelAgetic.vue?vue&type=style&index=0&id=1b82f968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports